import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './styles/theme.css';

import SiteLayout from './MainWebsite/GlobalComp/SiteLayout/SiteLayout';
import Home from './MainWebsite/Pages/Home/Home';
import ContactUs from './MainWebsite/Pages/ContactUs/ContactUs';
import PrivacyPolicy from './MainWebsite/Pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './MainWebsite/Pages/TermsOfService/TermsOfService';
import ServiceArea from './MainWebsite/Pages/ServiceArea/ServiceArea';
import Service from './MainWebsite/Pages/Service/Service';
import NotFound from './MainWebsite/Pages/NotFound/NotFound';
import { SERVICES } from './data/services';
import { SERVICE_AREAS } from './data/serviceAreas';

// Every page that scripts/prerender.js writes to static HTML at build time.
export const PRERENDER_ROUTES = [
  '/',
  ...SERVICES.map((s) => `/services/${s.slug}`),
  ...SERVICE_AREAS.map((a) => `/service-areas/${a.slug}`),
  '/contact-us',
  '/privacy-policy',
  '/terms-of-service',
];

// Routes without a router, so the browser (BrowserRouter) and the prerender
// step (StaticRouter in src/ssr.js) render the same tree.
export function AppContent() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path='/' element={<Home />} />
        <Route path='/services/:slug' element={<Service />} />
        {/* The old index page was removed; send it to the home page section. */}
        <Route path='/service-areas' element={<Navigate to='/#service-areas' replace />} />
        <Route path='/service-areas/:slug' element={<ServiceArea />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-of-service' element={<TermsOfService />} />
        <Route path='*' element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
